module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/hero-b3d70d4c71b92b037957f354e15e469d.jpg";